import { Component, EventEmitter, Input, Output } from '@angular/core';

export type ItemListRowTone = 'default' | 'success' | 'warning' | 'error';

/** One clickable row inside `app-item-list` — the Known Devices row shape, shared. */
@Component({
  selector: 'app-item-list-row',
  templateUrl: './item-list-row.component.html',
  styleUrl: './item-list-row.component.scss',
})
export class ItemListRowComponent {
  @Input() tone: ItemListRowTone = 'default';
  @Input() pulse = false;
  @Input() selected = false;
  /** Known Devices shows a live/presence dot; other lists express status via a trailing pill
   *  instead (see webhooks) and should turn this off rather than double up on indicators. */
  @Input() showDot = true;
  @Output() activate = new EventEmitter<void>();

  onActivate(): void {
    this.activate.emit();
  }
}
